'use client'

import classnames from 'classnames'
import styles from './GiftCards.module.scss'
import SanityImage from '@/components/SanityImage/SanityImage'
import Button from '@/components/Button/Button'
import Widont from '@/components/Widont/Widont'
import VideoLoop from '@/components/VideoLoop/VideoLoop'
import AnimateContainer from '@/components/AnimateContainer/AnimateContainer'
import RichText from '@/components/RichText/RichText'
import Link from '@/components/Link/Link'

const GiftCards = ({ className, items }: SanityGiftCards) => {
  if (!items?.american || !items?.canadian) return null

  return (
    <div className={classnames(styles.GiftCards, className)}>
      <div className={styles.inner}>
        <ul className={styles.list}>
          {[items.american, items.canadian].map((item, i) => (
            <AnimateContainer
              element="li"
              animationType="fadeInUp"
              className={styles.item}
              delay={i * 0.3}
              key={i}
            >
              <article className={styles.itemInner}>
                {item.mediaType === 'image' && item?.image && (
                  <div
                    className={styles.imageContainer}
                    style={{
                      width: item.imageSize,
                      borderRadius: item.isImageRounded ? '50%' : undefined,
                    }}
                  >
                    <SanityImage
                      image={item.image}
                      className={styles.image}
                      breakpoints={{
                        tablet: {
                          width: 1100,
                          image: item.image,
                        },
                        xs: {
                          width: 800,
                          image: item.image,
                        },
                      }}
                    />
                  </div>
                )}
                {item.mediaType === 'video' && item.videoLoopMobile && item.videoLoopDesktop && (
                  <div className={styles.imageContainer}>
                    <VideoLoop
                      desktopLoop={item.videoLoopDesktop}
                      mobileLoop={item.videoLoopMobile}
                      desktopSizeMb={3}
                      mobileSizeMb={0.75}
                      className={styles.video}
                    />
                  </div>
                )}
                {item.flag && (
                  <div className={styles.flagContainer}>
                    <SanityImage
                      image={item.flag}
                      className={styles.flag}
                    />
                  </div>
                )}
                <div className={styles.textContent}>
                  <h1 className={styles.title}>
                    <Widont text={item.title} />
                  </h1>
                  {item.description && (
                    <p className={styles.description}>
                      <Widont text={item.description} />
                    </p>
                  )}

                  <div className={styles.ctaContainer}>
                    {((item.cta1 && item.cta1.linkType !== 'disabled') ||
                      (item.cta2 && item.cta2.linkType !== 'disabled')) && (
                      <div className={styles.topRow}>
                        {item.cta1 && (
                          <Button
                            link={item.cta1}
                            className={styles.cta}
                            primary
                          />
                        )}
                        {item.cta2 && (
                          <Button
                            link={item.cta2}
                            className={styles.cta}
                            primary
                          />
                        )}
                      </div>
                    )}
                    <div className={styles.bottomRow}>
                      {item.cta3 && (
                        <Button
                          link={item.cta3}
                          className={styles.cta}
                        />
                      )}
                    </div>
                  </div>
                  {item.smallText && item.smallText.length > 0 && (
                    <div className={styles.smallText}>
                      <RichText
                        value={item.smallText}
                        components={{
                          marks: {
                            link: ({ value, text }) => (
                              <Link
                                link={{
                                  ...value,
                                  label: text,
                                }}
                              />
                            ),
                          },
                        }}
                      />
                    </div>
                  )}
                </div>
              </article>
            </AnimateContainer>
          ))}
        </ul>
      </div>
    </div>
  )
}

GiftCards.displayName = 'GiftCards'

export default GiftCards
